<div
  class="reservation-card"
  [class.size-sm]="size === 'sm'"
  [class.size-md]="size === 'md'"
  [class.size-lg]="size === 'lg'"
  [class.is-inquiry]="status === 'inquiry'"
  [class.is-hold]="isHold"
  [class.has-dues]="hasDues"
  [matMenuTriggerFor]="usePopover ? popoverMenu : null"
  (click)="onCardClick($event)"
  (mouseenter)="onCardMouseEnter()"
  (mouseleave)="onCardMouseLeave()">
  <div class="card-body">
    <div class="avatar-col">
      <div
        class="avatar"
        [class.has-logo]="guestProfilePicture || (!isInquiry && sourceLogoUrl)"
        [style.background]="(guestProfilePicture || (!isInquiry && sourceLogoUrl)) ? '#ffffff' : avatarGradient">
        @if (guestProfilePicture) {
          <img class="avatar-logo profile-pic" [src]="guestProfilePicture" alt="" (error)="onProfilePictureError()" />
        } @else if (!isInquiry && sourceLogoUrl) {
          <img class="avatar-logo" [src]="sourceLogoUrl" alt="" (error)="onLogoError()" />
        } @else {
          <span class="avatar-initials">{{ initials }}</span>
        }
      </div>
    </div>
    <div class="text-col">
      <div class="title-row">
        <span class="guest-name">{{ dateRange }}</span>
        @if (isInquiry) {
          <span class="inquiry-chip">Inquiry</span>
        } @else if (isHold) {
          <span class="hold-chip">Hold</span>
        }
      </div>
    </div>
    <div class="actions-col">
      @if (hasGuidebook && size !== 'sm') {
        <button
          type="button"
          class="guidebook-btn"
          title="View Digital Guidebook"
          (click)="onGuidebookIcon($event)">
          <tidy-image [src]="'assets/svg/book-outline.svg'" class="guidebook-icon" />
        </button>
      }
    </div>
  </div>
</div>

<mat-menu
  #popoverMenu="matMenu"
  class="reservation-popover-menu"
  xPosition="after"
  [hasBackdrop]="!isDesktop">
  <!-- Lazy so each popover's lock-code lookup runs only when it opens. -->
  <ng-template matMenuContent>
    <app-reservation-popover
      [reservation]="reservation"
      [address]="address"
      [addressId]="addressId"
      (guidebookClick)="handleGuidebookFromPopover()"
      (detailsClick)="handleDetailsFromPopover()"
      (messageClick)="handleMessageFromPopover()"
      (hoverChange)="onPopoverHoverChange($event)" />
  </ng-template>
</mat-menu>
